import {
  FormGenContentItem,
  FormGenLayout,
  FormGenLayoutSource,
  FormGenRendererFactory
} from "../shared/FormGenContainer";
import {ReactElement} from "react";

export enum FyneAIFormGenMetadataType {
}

export class FyneAIFormGenRendererFactory implements FormGenRendererFactory<FyneAIFormGenMetadataType> {

  render(metadataType: FyneAIFormGenMetadataType, source: FormGenLayoutSource, layout: FormGenLayout, contentItem: FormGenContentItem, index: number): ReactElement {
    return null;
  }
}